// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import {
    UpdateWorkPool,
    UpdateWorkPoolMember,
    WorkPool,
    WorkPoolType,
} from "./types/resources/workPoolTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedEnterpriseCoachingCadreApi = createApi({
    reducerPath: "cclTokenedEnterpriseCoachingCadreApi",
    tagTypes: ["Cadres", "CurrentCadre"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllCadres: builder.query<WorkPool[], void>({
            query: () => ({
                url: "enterprise-coaching/v1/Cadre/all",
                method: "GET",
            }),
            providesTags: (_, __, ___) => [{ type: "Cadres" }],
        }),
        getCadreByCkey: builder.query<WorkPool, number>({
            query: (cKey) => ({
                url: `enterprise-coaching/v1/Cadre/${cKey}`,
                method: "GET",
            }),
            providesTags: ["CurrentCadre"],
        }),
        getCadreByPkey: builder.query<WorkPool[], string>({
            query: (pkey) => ({
                url: `enterprise-coaching/v1/Cadre/Cadres/${pkey}`,
                method: "GET",
            }),
        }),
        deleteCadreByCkey: builder.mutation<number, number>({
            query: (cKey) => ({
                url: `enterprise-coaching/v1/Cadre/${cKey}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Cadres"],
        }),
        addCadreMember: builder.mutation<UpdateWorkPoolMember, UpdateWorkPoolMember>({
            query: (args) => ({
                url: `enterprise-coaching/v1/Cadre/members/add/${args.cKey}/${args.imKey}`,
                method: "POST",
            }),
            invalidatesTags: ["CurrentCadre"],
        }),
        removeCadreMember: builder.mutation<UpdateWorkPoolMember, UpdateWorkPoolMember>({
            query: (args) => ({
                url: `enterprise-coaching/v1/Cadre/members/remove/${args.cKey}/${args.imKey}`,
                method: "POST",
            }),
            invalidatesTags: ["CurrentCadre"],
        }),
        addNewCadre: builder.mutation<UpdateWorkPool, UpdateWorkPool>({
            query: (args) => ({
                url: `enterprise-coaching/v1/Cadre`,
                method: "PUT",
                body: args,
            }),
            invalidatesTags: ["Cadres"],
        }),
        updateCadreDetails: builder.mutation<UpdateWorkPool, UpdateWorkPool>({
            query: (args) => ({
                url: `enterprise-coaching/v1/Cadre/update`,
                method: "POST",
                body: args,
            }),
            invalidatesTags: ["Cadres", "CurrentCadre"],
        }),
        updateCadreMemberAvailability: builder.mutation<UpdateWorkPoolMember, string[]>({
            query: (args) => ({
                url: `enterprise-coaching/v1/Cadre/members/update/availability/${args[0]}/${args[1]}`,
                method: "POST",
            }),
            invalidatesTags: ["CurrentCadre"],
        }),
        getAllCadreTypes: builder.query<WorkPoolType[], void>({
            query: () => ({
                url: "enterprise-coaching/v1/Cadre/types/all",
                method: "GET",
            }),
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetAllCadresQuery,
    useDeleteCadreByCkeyMutation,
    useGetCadreByCkeyQuery,
    useAddCadreMemberMutation,
    useRemoveCadreMemberMutation,
    useAddNewCadreMutation,
    useUpdateCadreDetailsMutation,
    useGetCadreByPkeyQuery,
    useUpdateCadreMemberAvailabilityMutation,
    useGetAllCadreTypesQuery,
} = cclTokenedEnterpriseCoachingCadreApi;
